import React, { useEffect, useState } from "react";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import { ErrorMessage } from "components/Common/toastify.jsx";
import get, { post } from "../../../../lib/requests";
import Loading from "components/Common/loading.jsx";
import { useDispatch, useSelector } from "react-redux";
import { setCustomer } from "redux/ducks/customerSlice.js";
import AccountAddDialog from "./AccountAddDialog.js";
import EmailPreview from "./EmailPreview.js";
import { useNavigate } from "react-router-dom";
import SubscriptionReportDialog from "./SubscriptionReportDialog.js";
import { LoadingMgs } from "components/Common/toastify.jsx";
import { SuccessMessage } from "components/Common/toastify.jsx";
import sectionCommentsStyle from "assets/jss/material-kit-pro-react/views/blogPostSections/sectionCommentsStyle.js";
import { setDashboard } from "redux/ducks/CSPDashboardSlice";

const useStyles2 = makeStyles(headersStyle);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);
const useStyles = makeStyles(sectionCommentsStyle);

const CustomerList = () => {
	const classes2 = useStyles2();
	const [originalData, setOriginalData] = useState([]);
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const [customerList, setCustomerList] = useState([]);
	const [searchText, setSearchText] = useState("");
	const dispatch = useDispatch();

	const [sortBy, setSortBy] = useState("companyName");
	const [sortOrder, setSortOrder] = useState("asc");
	const [accountAddDialog, setAccountAddDialog] = useState(false);
	const [subscriptionReportDialog, setSubscriptionReportDialog] = useState(
		false
	);
	const [emailPreview, setEmailPreview] = useState(false);
	const [emailPreviewData, setEmailPreviewData] = useState(null);
	const customerDetails = useSelector((state) => state.customer);
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		getCustomerList();
		getCustomerFilter();
		return function cleanup() {};
	}, []);

	const getCustomerList = async () => {
		setLoading(true);
		// Get the list of customers
		try {
			await get(`/api/customers/list?srch=${searchText}`, true)
				.then((res) => {
					if (res.data.success) {
						const data = res.data.records;
						const sortedData = filterData(
							data?.customers,
							data?.user_filter?.sort_by,
							data?.user_filter?.sort_order
						);
						setSortBy(data?.user_filter?.sort_by);
						setSortOrder(data?.user_filter?.sort_order);
						setCustomerList({ customers: sortedData });
						setOriginalData(res.data.records);
					} else {
						ErrorMessage("Customer list", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Customer list", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Customer list", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const getCustomerFilter = async () => {
		setLoading(true);
		// Get the list of customers
		try {
			await get(`/api/customer/getfilter`, true)
				.then((res) => {
					if (res.data.success) {
						// console.log(res.data, "res.data");
					} else {
						ErrorMessage("customer filter", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("customer filter", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("customer filter", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const saveCustomerFilter = async (sort_by, sort_order) => {
		setLoading(true);
		const formField = {
			seach: "",
			sort_by: sort_by,
			sort_order: sort_order,
		};

		// Get the list of customers
		try {
			await post(`/api/customer/savefilter`, formField, true)
				.then((res) => {
					if (res.data.success) {
					} else {
						ErrorMessage("customer filter", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("customer filter", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("customer filter", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const selectCustomer = (customer) => {
		const dashboardData = {
			Heading: "Microsoft 365",
			TeamT5Form: false,
			KinetixForm: false,
			CustomerSubscriptionDetails: true,
			AddCustomerSubscription: false,
			selectedDialogData: null,
			ConfirmOrder: false,
			OrderSummary: false,
		};
		dispatch(setDashboard(dashboardData));
		navigate("/account");

		dispatch(setCustomer(customer));
	};

	const handleSearch = (e) => {
		setSearchText(e.target.value);
		manageCustomerSearch(e.target.value);
	};

	const manageCustomerSearch = (value) => {
		const searchTerm = value.trim().toLowerCase();

		if (searchTerm.length > 0) {
			const filteredData = originalData?.customers?.filter((customer) => {
				const companyName = customer?.companyName || "";
				const domain = customer?.domain || "";
				return (
					companyName.toLowerCase().includes(searchTerm) ||
					domain.toLowerCase().includes(searchTerm)
				);
			});
			setCustomerList({ customers: filteredData });
		} else {
			setCustomerList(originalData);
		}
	};

	const handleClear = () => {
		document.getElementById("search").value = "";
		manageCustomerSearch("");
	};

	const checkCustomer = (customer) => {
		return customerDetails?.tenantId === customer?.tenantId;
	};

	const pinUpPinCustomer = async (customer) => {
		setLoading(true);
		LoadingMgs("Pin Customer", "processing...");
		try {
			const formField = {
				tenantId: customer.tenantId,
			};
			await post(`/api/customer/pinthis`, formField, true)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Pin Customer", res.data.records.message);
						getCustomerList();
					} else {
						ErrorMessage("Pin Customer", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Pin Customer", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Pin Customer", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const filterCompanyName = (newSortOrder) => {
		const sortedData = filterData(
			customerList?.customers,
			"companyName",
			newSortOrder
		);
		setSortBy("companyName");
		setSortOrder(newSortOrder);
		setCustomerList({ customers: sortedData });
		saveCustomerFilter("companyName", newSortOrder);
	};

	const filterData = (data, sort_by, sort_order) => {
		const sortedData = [...data].sort((a, b) => {
			if (sort_by === "companyName") {
				if (sort_order === "asc") {
					return a.companyName.localeCompare(b.companyName);
				} else {
					return b.companyName.localeCompare(a.companyName);
				}
			} else if (sort_by === "Amount") {
				const amountA = Number(a.Amount);
				const amountB = Number(b.Amount);
				return sort_order === "asc" ? amountA - amountB : amountB - amountA;
			}
		});
		return sortedData;
	};

	const filterAmount = (newSortOrder) => {
		const sortedData = filterData(
			customerList?.customers,
			"Amount",
			newSortOrder
		);

		setSortBy("Amount");
		setSortOrder(newSortOrder);
		setCustomerList({ customers: sortedData });
		saveCustomerFilter("Amount", newSortOrder);
	};

	return (
		<>
			<div className={classNames(classesCSStyles.customerListWrapper)}>
				<div className={classNames(classes2.mlAuto)}>
					<div
						className={classNames(
							classesCSStyles.customerTitle,
							classes2.mlAuto,
							"flex"
						)}>
						Customers &nbsp;
						<div className={classesCSStyles.companyStatus}>
							({customerList?.customers?.length || 0})
						</div>
						&nbsp; &nbsp;
						<div
							className={classNames(classesCSStyles.clearIcon)}
							onClick={() => {
								const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
								filterCompanyName(newSortOrder);
							}}>
							<i className="fas fa-sort" />
						</div>
						&nbsp; &nbsp;
						<div
							className={classNames(classesCSStyles.clearIcon)}
							onClick={() => {
								const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
								filterAmount(newSortOrder);
							}}>
							<i className="fas fa-sort-amount-up" />
						</div>
					</div>
					<div
						className={classNames(classesCSStyles.searchWrapper, classes2.mlAuto)}>
						<input
							type="text"
							id="search"
							placeholder="Search Customer"
							className={classNames(classesCSStyles.searchInput)}
							onChange={(e) => {
								handleSearch(e);
							}}
						/>

						<div className={classNames(classesCSStyles.clearIcon)}>
							<span
								className={classNames(classesCSStyles.clearIcon)}
								onClick={() => {
									handleClear();
								}}>
								x
							</span>
						</div>
					</div>
				</div>
				<ul className={classNames(classesCSStyles.customerList)}>
					{loading && (
						<li>
							<Loading
								width={30}
								height={30}
								className={classesCSStyles?.absoluteLoading}
							/>
						</li>
					)}
					<div className={loading ? classesCSStyles.loading : ""}>
						{customerList?.customers?.map((customer, index) => (
							<li
								key={index}
								className={classNames(
									classesCSStyles.customerTile,
									checkCustomer(customer) ? classesCSStyles.selectedTiles : ""
								)}>
								<div className={classNames("flex", classesCSStyles.customerListHeader)}>
									<h3
										onClick={() => selectCustomer(customer)}
										className={classesCSStyles.customerListHeaderTitle}>
										{customer.companyName}
									</h3>
									<div className={classNames(classesCSStyles.positionToRight)}>
										<i
											onClick={() => pinUpPinCustomer(customer)}
											className="fas fa-thumbtack"
											style={{
												color: customer?.pinned ? "#031825FF" : "#ccc",
												cursor: "pointer",
											}}
										/>
									</div>
								</div>
								<div
									className={classNames(classesCSStyles.customerListDetails)}
									onClick={() => selectCustomer(customer)}>
									<div>
										Status :{customer?.cansubscribe ? " Active" : " In-Active"} (
										{customer?.total_subscription})
									</div>{" "}
									<div> Amount : ${customer?.Amount || "0.0"}</div>
								</div>
							</li>
						))}
					</div>
					{customerList?.customers?.length === 0 && (
						<li className={classNames(classesCSStyles.noCustomer)}>
							No customer found
						</li>
					)}
				</ul>
			</div>
			{accountAddDialog && (
				<AccountAddDialog
					accountAddDialog={accountAddDialog}
					setAccountAddDialog={setAccountAddDialog}
					emailPreviewData={emailPreviewData}
					setEmailPreview={setEmailPreview}
					setEmailPreviewData={setEmailPreviewData}
				/>
			)}
			{subscriptionReportDialog && (
				<SubscriptionReportDialog
					subscriptionReportDialog={subscriptionReportDialog}
					setSubscriptionReportDialog={setSubscriptionReportDialog}
				/>
			)}
			{emailPreview && (
				<EmailPreview
					emailPreview={emailPreview}
					setEmailPreview={setEmailPreview}
					emailPreviewData={emailPreviewData}
					setEmailPreviewData={setEmailPreviewData}
				/>
			)}
		</>
	);
};

export default CustomerList;
